// 订单相关的API函数

import request from '@/utils/request'

//创建视频订单
export const createVideoOrder = (params) => {
    return request('/user/vorder/create', 'post', params)
}
//创建题库订单
export const createTestsOrder = (params) => {
    return request('/user/torder/create', 'post', params)
}
//创建图书订单
export const createBooksOrder = (params) => {
    return request('/user/border/create', 'post', params)
}


//获取订单详情
export const findOrderDetail = (orderID) => {
    return request(`/user/order?orderID=${orderID}`, 'get')
}
//删除订单
export const delOrder = (orderID) => {
    return request(`/user/delorder?orderID=${orderID}`, 'delete')
}
//支付宝支付请求

export const findAliPay = (orderID) => {
    return request(`/user/alipay?orderID=${orderID}`, 'get',)
}

//支付宝支付状态查询

export const aliPayOrderPayment = ({ out_trade_no, trade_no }) => {
    return request(`/user/alipayment`, 'post', { out_trade_no, trade_no })
}

//已支付订单查询

export const OrderPaid = ({ phone }) => {
    return request(`/user/orderpaid`, 'get', { phone })
}

//微信支付订单
export const findWxPay = (orderID) => {
    return request(`/user/wxpay?orderID=${orderID}`, 'get')
}

//查询微信订单支付状态 queryWxpay
export const queryWxpay = (orderID) => {
    return request(`/user/querywxpay?orderID=${orderID}`, 'get')
}